<template>
  <b-modal
    id="business-types-form-modal"
    hide-footer
    size="lg"
    title="Create new business type"
    @hidden="$emit('hidden')"
    @show="modalShown"
  >
    <b-form @submit.prevent="submit">
      <validation-observer ref="formRef">
        <b-card>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Label"
                rules="required"
              >
                <b-form-group
                  label="Label"
                  label-for="label"
                >
                  <b-form-input
                    id="label"
                    v-model="formData.label"
                    placeholder="Label"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Logical Id"
                rules="required"
              >
                <b-form-group
                  label="Logical Id"
                  label-for="logical-id"
                >
                  <b-form-input
                    id="logical-id"
                    v-model="formData.logicalId"
                    :disabled="editMode"
                    placeholder="Logical ID"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Description"
                rules="required"
              >
                <b-form-group
                  label="Description"
                  label-for="description"
                >
                  <b-form-input
                    id="description"
                    v-model="formData.description"
                    placeholder="Description"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Active"
                label-for="active"
              >
                <b-form-checkbox
                  id="active"
                  v-model="formData.active"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="12"
              class="d-flex align-items-center justify-content-center"
            >
              <b-button
                block
                variant="primary"
                type="submit"
                :disabled="submitting"
              >
                <b-spinner
                  v-if="submitting"
                  small
                />
                <span v-else>Save</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BCard,
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BRow,
  BCol,
  BFormCheckbox,
  BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BForm,
    BFormCheckbox,
    BFormInput,
    BSpinner,
    ValidationProvider,
    BButton,
    ValidationObserver,
    BFormGroup,
    BRow,
    BCol,
  },
  props: {
    businessType: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const editMode = ref(false)
    const formRef = ref(null)
    const formData = ref({
      label: '',
      logicalId: '',
      description: '',
      active: false,
    })

    const submitting = ref(false)
    const submit = async () => {
      const res = await formRef.value.validate()
      if (!res) return
      try {
        submitting.value = true
        if (props.businessType) {
          await ctx.root.$store.dispatch('business/updateBusinessType', {
            payload: formData.value,
            id: props.businessType.id,
          })
        } else {
          await ctx.root.$store.dispatch('business/createBusinessType', formData.value)
        }
        ctx.root.$bvModal.hide('business-types-form-modal')
        ctx.emit('business-type-created')
      } finally {
        submitting.value = false
      }
    }

    const modalShown = () => {
      if (props.businessType) {
        editMode.value = true
        Object.keys(props.businessType).forEach(k => {
          if (k in formData.value) {
            formData.value[k] = props.businessType[k]
          }
        })
      } else {
        editMode.value = false
        formData.value.label = ''
        formData.value.logicalId = ''
        formData.value.description = ''
      }
    }
    return {
      required,
      formData,
      modalShown,
      submit,
      submitting,
      formRef,
      editMode,
    }
  },
}
</script>

<style>

</style>
